import React from "react";

const Header = () => {
  return (
    <div className="header">
      <h2>Bulls and Cows</h2>
    </div>
  );
};

export default Header;
